import React from 'react';

/**
 * Icône N géométrique du logo NUDGE v3
 * Deux jambes verticales + diagonale + accent orange en haut à droite
 */
export const NudgeIcon: React.FC<{ className?: string }> = ({ className = 'w-8 h-8' }) => (
  <svg viewBox="0 0 512 512" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="512" height="512" rx="108" fill="#4f46e5" />
    <rect x="148" y="128" width="72" height="256" fill="white" />
    <rect x="292" y="128" width="72" height="256" fill="white" />
    <polygon points="148,128 220,128 364,384 292,384" fill="white" />
    <polygon points="316,128 364,128 364,176" fill="#f97316" />
  </svg>
);

/**
 * Icône N sans fond (pour utilisation sur fond coloré)
 */
export const NudgeIconMark: React.FC<{ className?: string }> = ({ className = 'w-5 h-5' }) => (
  <svg viewBox="0 0 512 512" className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <rect x="148" y="128" width="72" height="256" />
    <rect x="292" y="128" width="72" height="256" />
    <polygon points="148,128 220,128 364,384 292,384" />
    <polygon points="316,128 364,128 364,176" fill="#f97316" />
  </svg>
);

/**
 * Wordmark complet : icône + texte NUDGE
 * variant: 'light' (fond clair, texte indigo) | 'dark' (fond sombre, texte blanc) | 'onBrand' (sur fond indigo, tout blanc)
 */
export const NudgeWordmark: React.FC<{
  variant?: 'light' | 'dark' | 'onBrand';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}> = ({ variant = 'light', size = 'md', className = '' }) => {
  const iconSizes = { sm: 'w-7 h-7', md: 'w-9 h-9', lg: 'w-11 h-11' };
  const textSizes = { sm: 'text-lg', md: 'text-xl', lg: 'text-2xl' };
  const textColors = {
    light: 'text-primary-600',
    dark: 'text-white',
    onBrand: 'text-white',
  };

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <NudgeIcon className={iconSizes[size]} />
      <span className={`font-bold tracking-tight ${textSizes[size]} ${textColors[variant]}`}>
        NUDGE
      </span>
    </div>
  );
};
